import React, { useState, useEffect, useContext, useRef } from 'react';
import isEqual from 'lodash.isequal';
import moment from 'moment';
import  PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
    PageSectionHeading,
    SectionSubHeading,
    PagePrimaryNumber,
} from '../../../../../../CommonComponents/commonStyles';
import { startDate, initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import { findInvestmentOptionsByAccountIdFromDateAndToDate, updateRecurringExchange, updateSingleExchange, editExchangeSpawnByScheduleId } from '../../../../../../services/apiServices';
import formatter from "../../../../../../utils/formatter";
import Context from '../../context';
import { DollarWrapper, CustomSectionSpacing, ButtonWrapper, ToNavigationBtnContainer } from './styles';
import Table from './Table';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import {
    ScheduleType as ScheduleTypeConstants,
    ExchangeType as ExchangeTypeConstants,
    AllocationType as AllocationTypeConstants,
    Frequency as FrequencyConstants,
    isTIFF
} from '../../constants';
import { getAccountData } from '../../../../../../utils/sessionUtil';
import queryString from "query-string";
import { checkCSRBusinessFunction } from '../../../../../../CSR/utils/CommonUtils';
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import { GeneralButton } from '../../../../../../CommonComponents/Commons/commonComponents';

const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

const ExchangeTo = (props) => {
    const { history, userId, handleExit, handleCancel, id, referencePools = [], persistContext, edit,
        isDirty, isNew, location, setDirty, exchangeDetails, handleCancelConfirmation, isSpawn, exchPendingSpawnId, accountType, csrBusinessFunction } = props;
    const { exchangeContext } = useContext(Context);
    const { from, to } = exchangeContext || {};
    const [poolsData, setPoolsData] = useState();
    const [usedPercentage, setUsedPercentage] = useState(0);
    const [isError, setError] = useState(false);
    const [isNextClicked, setNextClicked] = useState(false);
    const inputs = { accountId: userId, startDate: startDate(7), endDate: moment().format('MM/DD/YYYY') };
    const { partyId } = getAccountData();

    const previousReferencePools = usePrevious(referencePools);
    const previousContext = usePrevious(exchangeContext);
    const previousInputs = usePrevious(inputs);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const mapReferencePools = (tmpPools) => {
            const pools = { ...tmpPools };
            // merge pools data from step 1 to this. - start
            pools.portfolioSolutions = pools.portfolioSolutions && pools.portfolioSolutions.map((item) => {
                const ref = referencePools.find((i) => i.poolId === item.id);
                const pool = { ...item };
                if (ref) {
                    pool.availableBalance = ref.availableBalance;
                    pool.availableUnits = ref.availableUnits;
                }
                return pool;
            });
            pools.portfolioBuilders = pools.portfolioBuilders && pools.portfolioBuilders.map((item) => {
                const ref = referencePools.find((i) => i.poolId === item.id);
                const pool = { ...item };
                if (ref) {
                    pool.availableBalance = ref.availableBalance;
                    pool.availableUnits = ref.availableUnits;
                }
                return pool;
            });
            pools.valueDriven = pools.valueDriven && pools.valueDriven.map((item) => {
                const ref = referencePools.find((i) => i.poolId === item.id);
                const pool = { ...item };
                if (ref) {
                    pool.availableBalance = ref.availableBalance;
                    pool.availableUnits = ref.availableUnits;
                }
                return pool;
            });
            return pools;
        }

        const mapExchangeContext = (tmpPools) => {
            const pools = { ...tmpPools };
            const { to } = exchangeContext;
            const { pools: toPools } = to;
            if (toPools && toPools.length > 0) {
                pools.portfolioSolutions = pools.portfolioSolutions && pools.portfolioSolutions.map((item) => {
                    const pool = toPools.find((i) => i.poolId === item.id || i.id === item.id);
                    return {
                        ...item,
                        percentage: pool && pool.percentage
                    }
                });
                pools.portfolioBuilders = pools.portfolioBuilders && pools.portfolioBuilders.map((item) => {
                    const pool = toPools.find((i) => i.poolId === item.id || i.id === item.id);
                    return {
                        ...item,
                        percentage: pool && pool.percentage
                    }
                });
                pools.valueDriven = pools.valueDriven && pools.valueDriven.map((item) => {
                    const pool = toPools.find((i) => i.poolId === item.id || i.id === item.id);
                    return {
                        ...item,
                        percentage: pool && pool.percentage
                    }
                });
            }
            return pools;
        }

        const mapPools = (tmpPools) => {
            return mapReferencePools(mapExchangeContext(tmpPools));
        }

        if(!isEqual(previousInputs, inputs)) {
            findInvestmentOptionsByAccountIdFromDateAndToDate(inputs).then((res) => {
                let tmpPoolsData = res.data.find((item) => `${item.accountId}` === `${userId}` && item.accountType && accountType && item.accountType.toLowerCase() === accountType.toLowerCase());
                tmpPoolsData.portfolioSolutions = tmpPoolsData && tmpPoolsData.portfolioSolutions.filter((pool, i) => !isTIFF(pool.investmentOption))
                tmpPoolsData.portfolioBuilders = tmpPoolsData && tmpPoolsData.portfolioBuilders.filter((pool, i) => !isTIFF(pool.investmentOption))
                tmpPoolsData.valueDriven = tmpPoolsData && tmpPoolsData.valueDriven.filter((pool, i) => !isTIFF(pool.investmentOption))
                setPoolsData(mapPools(tmpPoolsData));
            });
        } else if (!isEqual(previousReferencePools, referencePools) || !isEqual(previousContext, exchangeContext)) {
            poolsData && setPoolsData(mapPools(poolsData));
        } 
    }, [referencePools, exchangeContext, inputs]);


    const navigateBackToView = (data, isSingle) => {
        const id = isSingle ? data.txnId : data.scheduleId;
        // TODO: Put it in context or ask page to get exchange details as view flow 
        window.sessionStorage.removeItem('recommend-an-exchange');
        const query = queryString.parse(location.search);
        setDirty(false);
        if (isSpawn) {
            history.push({
                pathname: `/investments/recommend-an-exchange/${id}/spawn/${exchPendingSpawnId}/view`,
                search: `type=${query.type}`
            })
        } else {
            history.push({
                pathname: `/investments/recommend-an-exchange/${id}/view`,
                search: `type=${query.type}`
            });
        }
    };

    const handleUpdateSubmit = () => {
        if(!checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')) {
            const data = {
                partyId: partyId,
                startDate: from.scheduleType === ScheduleTypeConstants.onetime ? moment().format("MM/DD/YYYY") :
                    from.scheduleType === ScheduleTypeConstants.recurring ? moment(from.startDate).format("MM/DD/YYYY") : '',
                exchangeType: from.exchangeType === ExchangeTypeConstants.custom ? 'Custom Exchange' :
                    from.exchangeType === ExchangeTypeConstants.reallocation ? 'Reallocation Exchange' : '',
                category: from.scheduleType === ScheduleTypeConstants.onetime ? 'Single Exchange' :
                    from.scheduleType === ScheduleTypeConstants.recurring ? 'Recurring Exchange' : '',
                unit: from.exchangeType === ExchangeTypeConstants.reallocation ? 'DOLLAR' :
                    from.allocationType === AllocationTypeConstants.unit ? 'UNITS' :
                        from.allocationType === AllocationTypeConstants.dollar ? 'DOLLAR' :
                            from.allocationType === AllocationTypeConstants.percentage ? 'PERCENT' : '',
                exchangeFrom: from.pools.map((item) => {
                    return {
                        poolId: item.poolId,
                        pool: item.poolName,
                        value: from.allocationType === AllocationTypeConstants.unit ? item.unit :
                            from.allocationType === AllocationTypeConstants.dollar ? item.dollar :
                                from.allocationType === AllocationTypeConstants.percentage ? item.percentage : '',
                    };
                }),
                exchangeTo: to.pools.map((item) => {
                    return {
                        poolId: item.poolId,
                        pool: item.investmentOption,
                        percentage: item.percentage
                    };
                }),
            }

            if (from.scheduleType === ScheduleTypeConstants.onetime) {
                data.txnId = exchangeDetails.transactionId;
            } else if (from.scheduleType === ScheduleTypeConstants.recurring) {
                data.scheduleId = exchangeDetails.exchScheduleId;
                data.endDate = moment(from.endDate).format("MM/DD/YYYY");
                data.frequency = from.frequency === FrequencyConstants.weekly ? 'Weekly'
                    : from.frequency === FrequencyConstants.monthly ? 'Monthly'
                        : from.frequency === FrequencyConstants.quaterly ? 'Quarterly' : '';
                data.startDay = 'Monday';
                data.numberOfExchanges = from.numberOfExchanges.toString();
            }

            if (from.scheduleType === ScheduleTypeConstants.onetime) {
                return updateSingleExchange({ accountId: userId, data }).then((res) => {
                    initiateTracking('update', 'View and Edit Exchange', 'Recommend exchange to', 'Update - One Time Exchange');
                    navigateBackToView(data, true);
                });
            } else if (from.scheduleType === ScheduleTypeConstants.recurring) {
                return updateRecurringExchange({ accountId: userId, data }).then((res) => {
                    initiateTracking('update', 'View and Edit Exchange', 'Recommend exchange to', 'Update - Recurring Exchange');
                    navigateBackToView(data, false);
                });
            }
        }
    };

    const handleSpawnUpdateSubmit = () => {
        if(!checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')) {
            // here spawn data is coming as exchangeDetails
            const spawnDetails = { ...exchangeDetails };
            // FIXME: update spawns API call changes
            const data = {
                partyId: partyId,
                exchangeStartDate: moment(from.startDate).format("MM/DD/YYYY"),
                instructionType: from.allocationType === AllocationTypeConstants.unit ? 'UNITS' :
                    from.allocationType === AllocationTypeConstants.dollar ? 'DOLLAR' :
                        from.allocationType === AllocationTypeConstants.percentage ? 'PERCENT' : '',
                exchangePendingSpawnId: exchangeDetails.exchangePendingSpawnId,
                exchangeType: exchangeDetails.exchangeType,
                orderId: exchangeDetails.orderId,
                scheduleId: exchangeDetails.scheduleId,
                exchangeId: exchangeDetails.exchangeId,
                exchangeFrom: from.pools.map((item) => {
                    return {
                        poolId: item.poolId,
                        pool: item.poolName,
                        value: from.allocationType === AllocationTypeConstants.unit ? item.unit :
                            from.allocationType === AllocationTypeConstants.dollar ? item.dollar :
                                from.allocationType === AllocationTypeConstants.percentage ? item.percentage : '',
                    };
                }),
                exchangeTo: to.pools.map((item) => {
                    return {
                        poolId: item.poolId,
                        pool: item.investmentOption,
                        percentage: item.percentage
                    };
                }),
            }
            return editExchangeSpawnByScheduleId({ accountId: userId, data: data }).then((res) => {
                initiateTracking('update', ' View and Edit Recurring Exchange Spawn', 'Recommend exchange to', 'Update');
                navigateBackToView(spawnDetails, false);
            });
        }
    }


    const handleNext = () => {
        try {
            if(usedPercentage === 100){
                if (isNew) {
                    persistContext();
                    if (location && location.state && location.state.prev) {
                        history.push({
                            pathname: location.state.prev.pathname,
                            search: location.state.prev.search,
                        });
                    } else {
                        // if(!checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')) {
                            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange'
                            initiateTracking('update', 'Recommend An Exchange', 'Step 2 Recommend exchange to', `Update - ${scheduleTypeLabel}`);
                            history.push(`/investments/recommend-an-exchange/${id}/review`)
                        // }
                    }
                } else {
                    // Call update for the changes
                    if (isSpawn) {
                        handleSpawnUpdateSubmit();
                    } else {
                        // Call update for the changes
                        handleUpdateSubmit();
                    }
                }
            } else {
                setNextClicked(true)
            }
        } catch (error) {
            recordError(error);
        }
    }

    const handleBack = () => {
        try {
            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange'
            initiateTracking('back', 'Recommend An Exchange', 'Step 2 Recommend exchange to', `Back - ${scheduleTypeLabel}`);
            history.push({
                pathname: `/investments/recommend-an-exchange/${id}/from`,
                search: location.search.edit
            });
        } catch (error) {
          recordError(error);
        }
    }

    const onHandleCancel = () => {
        try {
            const pageTitle = isNew ? 'Recommend An Exchange' : 'View and Edit Exchange';
            const isStep = isNew ? 'Step 2 ': '';
            const scheduleTypeLabel = from.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
            if(isSpawn) {
                initiateTracking('cancel', 'View and Edit Recurring Exchange Spawn', 'Recommend exchange to', 'Cancel');
            } else {
                initiateTracking('cancel', `${pageTitle}`, `${isStep}Recommend exchange to`, `Cancel - ${scheduleTypeLabel}`);
            }
            if(isDirty) {
                handleCancel()
            } else {
                handleCancelConfirmation()
            }
        } catch (error) {
          recordError(error);
        }
    }

    // Check the feature is avalilable by the particular csr user
    const checkCsrBusiness = businessFunction => {
        return checkCSRBusinessFunction(BUSINESS_FUNCTION[businessFunction], csrBusinessFunction);
    }

    return (
        <div data-test="container">
            <PageSectionHeading>Recommend exchange to</PageSectionHeading>
            <SectionSubHeading>
                Recommend which investment options you would like funds allocated to.
            </SectionSubHeading>
            <DollarWrapper>
                <div>Total estimated exchange amount:</div>
                <div>
                    <Context.Consumer>
                        {context => {
                            const { exchangeContext } = context;
                            const { from } = exchangeContext;
                            const { total } = from;
                            return (<PagePrimaryNumber>
                                {formatter({ value: total, fieldSuffix: "Dollars" })}
                            </PagePrimaryNumber>)
                        }}
                    </Context.Consumer>

                </div>
            </DollarWrapper>
            <CustomSectionSpacing>
                {!(poolsData) && <Preloader />}
                {poolsData && <Table
                    poolsData={poolsData}
                    data-test="test-table"
                    handleError={setError}
                    isDirty={isDirty}
                    setDirty={setDirty}
                    setUsedPercentage={setUsedPercentage}
                    usedPercentage={usedPercentage}
                    isNextClicked={isNextClicked}
                    setNextClicked={setNextClicked}
                />}
            </CustomSectionSpacing>
            {!edit && <ToNavigationBtnContainer className="flex">
                <ButtonWrapper>
                    <GeneralButton data-test="back-button"  mobWidth="50%" type="functional" inverted={true} width="150px" text="Back" id="btnBack" onClick={handleBack}/>
                    <GeneralButton mobWidth="50%" type="functional" inverted={true} width="150px" text="Exit" id="btnExit" onClick={handleExit}/>
                </ButtonWrapper>
                <GeneralButton data-test="button-next" width="150px" text="Next" id="btnNext" onClick={handleNext}/>
            </ToNavigationBtnContainer>}
            {edit && <ToNavigationBtnContainer className="flex">
                <GeneralButton type="functional" inverted={true} width="150px" text="Cancel" id="btnCancel" onClick={onHandleCancel} data-test="handleCancel"/>
                <GeneralButton width="150px" text="Update" id="btnUpdate" 
                    disabled={checkCsrBusiness('DONOR_PORTAL_EDIT_RECURRING_EXCHANGE_FULL_ACCESS')} 
                    onClick={handleNext}
                />
            </ToNavigationBtnContainer>}
        </div>
    );
};

ExchangeTo.propTypes = {
    referencePools: PropTypes.array,
    userId: PropTypes.string,
    handleExit: PropTypes.func,
    handleCancel: PropTypes.func,
    handleBack: PropTypes.func,
    edit: PropTypes.bool,
    id: PropTypes.string,
    isDirty: PropTypes.bool,
    isNew: PropTypes.bool,
    handleCancelConfirmation: PropTypes.func
}

export default withRouter(ExchangeTo);